import React from 'react'

export default (props) => (
    <button type="button" onClick={props.back} className={props.className}>
        {props.hasOwnProperty('children') && props.children && <div>{props.children}</div>}
        {(!props.hasOwnProperty('children') || !props.children) && <div>
            Back
        </div>}
    </button>
)